import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Text } from 'native-base';
import { styles, PRODUCT, TARGET_NAME } from '../constants';
import { Dimensions } from 'react-native';
import { MIN_WIDTH } from '../styles/rzd';
import View from "react-native-web/src/exports/View";
// import { MIN_WIDTH } from '../constants';

let deviceWidth = Dimensions.get('window').width;

class BlockButton extends Component {
  handlerChange = (element) => {
    const { block, onChange } = this.props;

    onChange && onChange({
      block,
      element,
      value: element.value
    });
  }

  render() {
    const { block, disabled, label, shitfix, visible } = this.props;
    let backLabel;

    // if (shitfix && deviceWidth <= MIN_WIDTH) {
    //   backLabel = "<";
    // }

    return (
      <>
          {block.elements.map((element, i) => {
                let buttonStyle,
                    buttonText = styles.buttonText;
                element.action = element.action || { type: '' };

                if (element.action.type === 'getBlock' && shitfix && PRODUCT === TARGET_NAME.SOCMEDICA) {
                  // для кнопки Ничего из вышеперечисленного
                  buttonStyle = styles.buttonNoneOfTheAbove;
                  buttonText = styles.buttonTextNoneOfTheAbove;

                }else if (element.action.type === 'goBack' && !visible) {
                  buttonStyle = styles.buttonInvisible;
                } else if (element.action.type === 'goBack' && visible) {
                  buttonStyle = styles.buttonBack;
                } else if (element.action.type === 'getBlock' && disabled) {
                  buttonStyle = styles.buttonDisabled;
                } else {
                  buttonStyle = styles.button;
                }

                return <Button
                    disabled={element.action.type === 'getBlock' ? disabled : false}
                    style={buttonStyle}
                    key={i}
                    // onPress={() => this.handlerChange(element)}
                    onPressIn={() => this.handlerChange(element)}
                >
                  <Text style={buttonText}>{element.action.type === 'getBlock' ? label || element.label : backLabel || element.label}</Text>
                </Button>;
              }
          )}
      </>
    );
  }
}

BlockButton.propTypes = {
  block: PropTypes.object,
  disabled: PropTypes.bool,
  visible: PropTypes.bool,
  shitfix: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func
};

export default BlockButton;

